module.exports = "/_next/static/images/ee18e920467baffeb5d8b3155b0c89e7-loading-figures.svg";